<template>
  <div class="modal socialsignupv2-modal">
    <div class="socialsignupv2-container">
      <!-- Modal Header-->
      <div class="socialsignupv2-header">
        <img
          class="close-icon cursor"
          @click="closeSocialSignUp"
          src="/media/images/icon/close-black-icon.png"
          alt="close-black-icon.png"
        />
      </div>
      <!-- Modal Contents -->
      <div class="socialsignupv2-contents">
        <p class="socialsignupv2-contents-title" v-html="titleText">
        </p>
        <ul class="sociallogin-list">
          <li>
            <a tabindex="0" class="sociallogin-item naver" @click="goLogin('naver')">
              <img class="naver-nobg-icon" src="/media/images/icon/naver-nobg-icon.png" alt="naver-nobg-icon.png" />
              <span class="sociallogin-itemtext naver">Naver로 계속하기</span>
            </a>
          </li>
          <li>
            <a tabindex="0" class="sociallogin-item kakao" @click="goLogin('kakao')">
              <img class="kakao-nobg-icon" src="/media/images/icon/kakao-nobg-icon.png" alt="kakao-nobg-icon.png" />
              <span class="sociallogin-itemtext kakao">Kakao로 계속하기</span>
            </a>
          </li>
          <li>
            <a tabindex="0" class="sociallogin-item apple" @click="goLogin('apple')">
              <img class="apple-nobg-icon" src="/media/images/icon/apple-nobg-icon.png" alt="apple-nobg-icon.png" />
              <span class="sociallogin-itemtext apple">Apple로 계속하기</span>
            </a>
          </li>
          <li>
            <a tabindex="0" class="sociallogin-item kt" @click="goLogin('kt')">
              <img class="kt-nobg-icon" src="/media/images/icon/kt-nobg-icon.png" alt="apple-nobg-icon.png" />
              <span class="sociallogin-itemtext kt">사장이지로 계속하기</span>
            </a>
          </li>
        </ul>
        <a tabindex="0" class="email-login" @click="goLogin('email')"> 이메일로 계속하기 </a>
      </div>
    </div>
  </div>
</template>
<script>
import { SelectNaver, KaKaoLogin, AppleLogin, KtLogin } from '@/utils/socialLogin';
export default {
  props: {
    titleText: {
      type: String,
      default: '지금 로그인하고, <br />나를 위한 채널에 입장해보세요.'
    }
  },
  emits: ['close-socialsignup'],
  methods: {
    closeSocialSignUp() {
      this.$emit('close-socialsignup');
    },
    goLogin(route) {
      if (route === 'naver') {
        SelectNaver();
      } else if (route === 'kakao') {
        KaKaoLogin();
      } else if (route === 'apple') {
        AppleLogin();
      } else if (route === 'kt') {
        KtLogin();
      } else {
        this.$router.push({ path: '/login' });
      }
    }
  }
};
</script>
<style scoped src="@/assets/css/socialsignupv2/socialsignupv2.css"></style>
